module.exports = __webpack_public_path__ + "static/media/Vini.51cfdd30.JPG";